module.exports = __webpack_public_path__ + "img/icon-footer-social-fb.10bbe89f.svg";